import { createEvent } from 'effector';
import { debounce } from 'patronum';

export const getCitiesEv = createEvent();

export const getHexListEv = createEvent();

export const getHexCollectionEv = createEvent();

export const changeActiveCityEv = createEvent();

export const changeShowMetricEv = createEvent();

export const changeActiveMetricEv = createEvent();

export const changeShowChartsEv = createEvent();

export const changeActiveYearEv = createEvent();
export const debouncedActiveYearEv = debounce({
  source: changeActiveYearEv,
  timeout: 500,
});

export const showLoaderEv = createEvent();

export const hideLoaderEv = createEvent();

export const getFloodsAreaEv = createEvent();

export const getMudfloodsAreaEv = createEvent();

export const changeMetricDetailsEv = createEvent();
export const resetMetricDetailsEv = createEvent();

export const changeLanguageEv = createEvent();

export const downloadEv = createEvent();

export const revertChatFiltersEv = createEvent();

export const applyChatHexagonsEv = createEvent();

export const setMessagesEv = createEvent();

export const resetMessagesEv = createEvent();

export const saveChatHexagonsEv = createEvent();

export const setChatOpenEv = createEvent();

export const getChartsDataByCitiesEv = createEvent();
